import React, { useEffect, useState, useCallback } from "react";
import { Box, Hidden, useTheme } from "@material-ui/core";
import { useRouteMatch } from "react-router-dom";

import Authorities from "../../../../auth/authorities";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import withAuthority from "../../../../components/Auth/withAuthority";
import { fetchAllOffersInfo } from "../../../../services/eatprestoApp/offersService";
import PageHeaderMobile from "../../../../components/common/PageHeader/PageHeaderMobile";
import OfferTypes from "./OfferTypes";
import { CustomTheme } from "../../../../types/customTheme";
import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";

/**
 * Offers Component
 * Fetches offers data for a location and renders the OfferTypes component.
 */
const Offers: React.FC = () => {
  const [offers, setOffers] = useState<any[]>([]);
  const [error, setError] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isLoadingButton, setIsLoadingButton] = useState<boolean>(false);
  const [offerItemMap, setOfferItemMap] = useState<any>({});

  const match = useRouteMatch<{ locationId: string }>();

  const theme: CustomTheme = useTheme();

  const handleReStructureOfferItems = (input: any) => {
    const output: any = {};

    for (const item of input) {
      const itemId = item.id;
      const isActive = item.isActive;

      if (!item.groups) continue;

      for (const group of item.groups) {
        if (!group.members) continue;

        for (const member of group.members) {
          const memberId = member.memberId;
          if (!memberId) continue;

          if (!output[memberId]) {
            output[memberId] = {
              activeCount: 0,
              deActiveCount: 0,
              idList: [],
              offerNameList: [],
            };
          }

          // Increase active/deActive count
          if (isActive) {
            output[memberId].activeCount++;
          } else {
            output[memberId].deActiveCount++;
          }

          // Add parent id to idList (avoid duplicates)
          if (!output[memberId].idList.includes(itemId)) {
            output[memberId].idList.push(itemId);
            output[memberId].offerNameList.push(item.name);
          }
        }
      }
    }


    return output;
  };

  /**
   * Fetch all offer information for the location.
   */
  const getOfferInfo = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await fetchAllOffersInfo(match.params.locationId);
      const output = handleReStructureOfferItems(response.data.data || {});
      setOfferItemMap(output);
      setOffers(response.data.data || []);
    } catch (err) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
    } finally {
      setIsLoading(false);
    }
  }, [match.params.locationId]);

  useEffect(() => {
    document.title = "Eat Presto -  Promotional Offers";
    getOfferInfo();
  }, [getOfferInfo]);

  return (
    <>
      <Hidden lgUp>
        <PageHeaderMobile />
      </Hidden>
      <Box style={{ marginTop: 2 }}>
        <OfferTypes
          nodes={offers}
          isLoading={isLoading}
          getOfferInfo={getOfferInfo}
          setIsLoadingButton={setIsLoadingButton}
          isLoadingButton={isLoadingButton}
          offerItemMap={offerItemMap}
          setOfferItemMap={setOfferItemMap}
        />
      </Box>
      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />
    </>
  );
};

export default withAuthority(Offers, Authorities.DISCOUNT_READ);
